import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade22,
  greyColor24,
  lightSkyBlue01,
  whiteColor,
} from "../../../configs/styles/muiThemes";

const InfoMessageCard = ({
  icon,
  iconBGColor,
  title,
  message,
  btnText,
  onClick,
}) => {
  return (
    <Stack alignItems="center" mt={3}>
      <Box sx={styles.infoCardIcon(iconBGColor)}>{icon}</Box>

      <Typography fontSize={14.5} fontWeight={500} color={blackColor} mt={2}>
        {title}
      </Typography>

      <Typography
        fontSize={12.5}
        fontWeight={400}
        color={greyColor24}
        mt={0.5}
        mb={1.5}
        textAlign="center"
      >
        {message}
      </Typography>

      {btnText && (
        <Button onClick={onClick} sx={styles.editBtn}>
          {btnText}
        </Button>
      )}
    </Stack>
  );
};

export default InfoMessageCard;

const styles = {
  infoCardIcon: (iconBGColor) => ({
    width: "60px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: iconBGColor || lightSkyBlue01,
    borderRadius: "10px",
  }),

  editBtn: {
    backgroundColor: blackShade22,
    padding: "2px 14px",
    fontSize: "12px",
    fontWeight: 600,
    color: whiteColor,
    border: "1.5px solid " + blackShade22,
    textTransform: "unset",
    "&:hover": {
      color: blackShade22,
      backgroundColor: whiteColor,
    },
  },
};
